import { StrictMode, startTransition } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'
import { domainHandoffUrl } from './utils/env'

const handoffUrl = domainHandoffUrl(
  window.location.hostname,
  window.location.pathname + window.location.search
)

if (handoffUrl) {
  window.location.replace(handoffUrl)
} else {
  startTransition(() => {
    hydrateRoot(
      document,
      <StrictMode>
        <HydratedRouter />
      </StrictMode>
    )
  })
}
